import { render, staticRenderFns } from "./chooseVisType.vue?vue&type=template&id=42bd4967"
import script from "./chooseVisType.vue?vue&type=script&lang=js"
export * from "./chooseVisType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports